import React, { useEffect, useRef, useState } from 'react'

import {
    FileExcelFilled,
    RightCircleOutlined,
    StopTwoTone,
    FileExcelOutlined,
    CheckCircleTwoTone,
    MinusSquareTwoTone
} from '@ant-design/icons';

import {
    Steps,
    message,
    Form,
    Button,
    Input,
    Space,
    Row,
    Col,
    Select,
    Tooltip,
    Alert} from 'antd';

import Dragger from 'antd/lib/upload/Dragger';
import { useSelector } from 'react-redux';
import { useForm } from 'antd/lib/form/Form';

import { createUploaderPropsPE } from '../../Functions';
import DrawerResume from '../DrawerResume';
import Spreadsheet, { CellBase, Matrix } from "react-spreadsheet";
import { useApi } from '../../../../Utils';

const MDW_RIPLEY_PE = '1';

type IAlmacen = {
    Codigo: string
    Estado: boolean
    FchReg: string
    NCorto: string
    Nombre: string
    Tipo: string
    UsuCrea: string
}

// function agruparPorComercial(data: any) {
//     return data.reduce((acc: any, item: any) => {
//         const key = item.Cd_Comercial;

//         if (!acc[key]) {
//             acc[key] = { Cd_Comercial: key, SALDO: 0 };
//         }

//         acc[key].SALDO += Number(item.SALDO) || 0;

//         return acc;
//     }, {});
// }


export default function WarehouseInjectorRipley({ rut = '83382700', rsocial = 'COMERCIAL ECCSA S.A.', setOptions }: {
    rut?: string
    rsocial?: string
    setOptions: React.Dispatch<React.SetStateAction<JSX.Element | undefined>>
}) {
    const { data: data_saveMdw, loading: loading_saveMdw, fetch: saveMdw, errors: errors_saveMdw } = useApi<any>('post', 'v3/pe/oc/save', {
        requiredToken: true,
        onRequest: true
    })

    // , errors: errors_createOP
    const { data: data_createOP, loading: loading_createOP, fetch: createOP } = useApi<any>('post', 'v3/pe/oc/create', {
        requiredToken: true,
        onRequest: true
    })

    useEffect(() => {
        console.log(errors_saveMdw)
    }, [errors_saveMdw])

    const [orderId, setOrderId] = useState()

    useEffect(() => {
        if (data_saveMdw?.success) {
            const msg = `Se ha creado el movimiento de inventario ${data_saveMdw.contanet_trf[2]} con el registro contable ${data_saveMdw.contanet_trf[0]}.`
            message.success({
                content: msg,
                duration: 30,
                key: `trfAlm${data_saveMdw.contanet_trf[2]}`
            })
            setFacturable(true)
            setOrderId(data_saveMdw.order.id)
        }
    }, [data_saveMdw])


    useEffect(() => {
        if (data_createOP?.success) {
            const ocs = Object.entries(data_createOP.contanet_op.association)
                .map(([key, value]) => `${key}: ${value}`)
                .join('\n');
            const msg = `Se han creado las órdenes: ${ocs}.`
            message.success({
                content: msg,
                duration: 30,
                key: `okOP`
            })
            // setFacturable(true)
            // setOrderId(data_createOP.order.id)
        }
    }, [data_createOP])

    const [step,setStep] = useState(0)
    const { token } = useSelector((state: any) => state)
    const [form] = useForm()

    const [preorder, setPreorder] = useState<any>()

    const [facturable, setFacturable] = useState(false)

    const [detailExcel, setDetailExcel] = useState<Matrix<CellBase>>([])
    const [detailExcelDetail, setDetailExcelDetail] = useState<Matrix<CellBase>>([])

    const baseCols = [
        "SKU",
        "Cód. Greta",
        "Descripción",
        "UPC",
        "Costo Neto Unitario",
        "Precio Unitario",
        "Solicitado",
        "Disponible"
    ]
    const [columnLabels, ] = useState<string[]>(baseCols)

    const baseColsDetail = [
        "SKU",
        "Cód. Greta",
        "Descripción",
        "UPC",
        "Cód. Sucursal",
        "Sucursal",
        "Solicitado",
        "Atención"
    ]
    const [columnLabelsDetail, ] = useState<string[]>(baseColsDetail)

    const [almacenes, setAlmacenes] = useState<IAlmacen[]>([])
    const [continueDisabled, setContinueDisabled] = useState<boolean>(true)
    const [selectedAlmacenes, setSelectedAlmacenes] = useState<string>()
    // const [data, setData] = useState<Matrix<CellBase>>([])

    const [codesWithoutHomologation, setCodesWithoutHomologation] = useState<string[]>([])
    const [codesBroken, setCodesBroken] = useState<string[]>([])
    const [codesPartial, setCodesPartial] = useState<string[]>([])
    
    const props = createUploaderPropsPE(token, MDW_RIPLEY_PE, form, '.csv', (file) => {
        console.log(file)
        setPreorder(file.response)
    })
    const [data, setData] = useState<any[]>([])

    const generateDetailTable = () => {
        const pendings = [] as string[]
        
        for (const lineExcelGeneral of detailExcel) {
            const sku = lineExcelGeneral[0]?.value
            const requested = lineExcelGeneral[6]?.value
            const attended = lineExcelGeneral[7]?.value

            if (requested !== attended && attended !== 0) {
                pendings.push(sku)
            }
        }

        const setter = preorder?.detailed?.reduce((acc: any[], line: any) => {
            if (pendings.includes(line.DET_ART_CLT)) {
                const gretaCode = preorder.homologated.find((h: any) => h.SKUCliente === line.DET_ART_CLT)
                
                const stockAvailable = preorder?.productoStock.reduce((acc: number, item: any) => {
                    let available = 0
                    if (item.Cd_Comercial === gretaCode?.CodComercial) {
                        available = item.SALDO
                    }
                    let _available = available + acc
                    if (_available > line.DET_ART_QTY) {
                        return Number(line.DET_ART_QTY)
                    }
                    return _available
                }, 0)
    
                const excelLine = [
                    // SKU Retail
                    { readOnly: true, value: line.DET_ART_CLT },
                    // SKU Greta
                    { readOnly: true, value: gretaCode?.CodComercial ?? '' },
                    // Descripción Retail
                    { readOnly: true, value: line.DET_ART_DSC },
                    // UPC Retail
                    { readOnly: true, value: line.DET_ART_UPC },
                    // Cód. Sucursal
                    { readOnly: true, value: line.DET_SUC_COD },
                    // Sucursal
                    { readOnly: true, value: line.DET_SUC_NOM },
                    // Solicitado
                    { readOnly: true, value: Number(line.DET_ART_QTY) },
                    // Disponible
                    { readOnly: false, value: stockAvailable, DataViewer: (props: any) => <StockColViewer refStock={refStock} key={`${line.DET_ART_CLT}${line.DET_SUC_COD}${JSON.stringify(rStk?.current)}`} {...props} line={line} />, CodCom: gretaCode?.CodComercial ?? '', requested: Number(line.DET_ART_QTY) }
                    // { readOnly: true, value: 3, DataViewer: RatingViewer }
                ]
                // console.log(excelLine)
                acc.push(excelLine)
            }
            return acc
        }, [])


        return setter
    }

    const generateBaseTable = () => {
        const broken = [] as string[]
        const partial = [] as string[]

        const setter = preorder?.consolidated?.reduce((acc: any[], line: any) => {
            const gretaCode = preorder.homologated.find((h: any) => h.SKUCliente === line.DET_ART_CLT)
            if (!gretaCode) {
                setCodesWithoutHomologation((_c: string[]) => {
                    _c.push(`El código ${line.DET_ART_CLT} no tiene homologación. Ingresa a Contanet ERP y asigna el producto correspondiente a ${line.DET_ART_DSC}`)
                    return _c
                })
            }
            const stockAvailable = preorder?.productoStock.reduce((acc: number, item: any) => {
                let available = 0
                if (item.Cd_Comercial === gretaCode?.CodComercial) {
                    available = item.SALDO
                }
                let _available = available + acc
                if (_available > line.DET_ART_QTY) {
                    return line.DET_ART_QTY
                }
                return _available
            }, 0)

            // console.log(stockAvailable, Number(line.))
            if (stockAvailable < Number(line.DET_ART_QTY)) {
                if (stockAvailable === 0) {
                    broken.push(line.DET_ART_CLT)
                } else {
                    partial.push(line.DET_ART_CLT)
                }
            }

            const excelLine = [
                // SKU Retail
                { readOnly: true, value: line.DET_ART_CLT },
                // SKU Greta
                { readOnly: true, value: gretaCode?.CodComercial ?? '' },
                // Descripción Retail
                { readOnly: true, value: line.DET_ART_DSC },
                // UPC Retail
                { readOnly: true, value: line.DET_ART_UPC },
                // Costo Neto Retail
                { readOnly: true, value: line.DET_ART_NET },
                // Precio Unitario Retail
                { readOnly: true, value: line.DET_ART_PUN },
                // Solicitado
                { readOnly: true, value: line.DET_ART_QTY },
                // Disponible
                { readOnly: true, value: stockAvailable, DataViewer: StockViewer, CodCom: gretaCode?.CodComercial ?? '', requested: line.DET_ART_QTY }
                // { readOnly: true, value: 3, DataViewer: RatingViewer }
            ]
            acc.push(excelLine)
            return acc
        }, [])

        console.log('generateTable', broken, partial)

        setCodesBroken(broken)
        setCodesPartial(partial)

        return setter
    }

    useEffect(() => {
        if (preorder) {
            setStep(1)
            setDetailExcel(generateBaseTable())
            setAlmacenes(preorder.almacenesPicking)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preorder])

    useEffect(() => {
        if (preorder && detailExcel) {
            if (!codesWithoutHomologation || !codesWithoutHomologation.length) {
                setContinueDisabled(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailExcel, codesWithoutHomologation])

    // useEffect(() => {
    //     // console.log(detailExcel)
    // }, [detailExcel])

    useEffect(() => {
        if (step === 2) {
            setDetailExcelDetail(generateDetailTable())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step])

    /* useEffect(() => {
        if (preorder) {
            // console.log(preorder)
            const cols = [...selectedAlmacenes]
            setColumnLabels([...baseCols, ...cols])
            // if (cols.length > 0) {

            // const oldSets = detailExcel.map(dE => {
            //     return dE.filter((dRE: any) => {
            //         return dRE?.Cod !== undefined
            //     })
            // })

            // console.log(detailExcel)
            const maxStocks = [] as any

            for (const col of cols) {
                const stocks = preorder.productoStock.filter((pS: any) => {
                    return pS.Cd_Alm === col
                }).map((pS: any) => {
                    return {
                        Cd_Comercial: pS.Cd_Comercial,
                        NroLote: pS.NroLote,
                        SALDO: pS.SALDO
                    }
                })
                maxStocks[col] = stocks
            }
            // console.log(maxStocks)


            const CODCOMERCIAL_COL = 1
            const REQUESTED_COL = 5
            const table = generateBaseTable().map((line: any) => {
                let i = 0;
                for (const col of cols) {
                    // Obtiene el solicitado por línea.
                    const requested = line[REQUESTED_COL]!.value
                    // Calculamos si ya se atendió la necesidad.
                    let attended = 0
                    if (i > 0) {
                        for (let index = 0; index < i; index++) {
                            // const element = array[index];
                            attended = attended + line[REQUESTED_COL + 1 + index].value
                        }
                    }
                
                    /**
                     * Actualizamos la columna nueva con la diferencia entre:
                     * - Lo faltante: que se traduce en lo Solicitado - Atendido.
                     * - Disponible almacen: que es el mayor valor entre el maxStocks acumulado por lotes y lo faltante.
                     *
                    const missing = requested - attended
                    const available = Object.values<any>(agruparPorComercial(maxStocks[col])).find(({ Cd_Comercial }: any) => {
                        return Cd_Comercial === line[CODCOMERCIAL_COL].value
                    })?.SALDO || 0
                    /*
                    
                    *

                    // console.log({
                    //     codcomercial: line[CODCOMERCIAL_COL].value,
                    //     requested, attended, missing, available
                    // })

                    line.push({
                        value: Math.min(missing, available),
                        Cod: col,
                        CodCom: line[CODCOMERCIAL_COL].value,
                        DataViewer: StockViewer
                    })
                    i++;
                }
                return line
            })
            setDetailExcel(table)
            // }
        }
    }, [selectedAlmacenes]) */

    useEffect(() => {
        switch(step) {
            case 0:
            case 1:
            case 2:
            case 3:
                // Barra general para exportar a Excel, refrescar inventarios, refrescar códigos de homologación y de guardar/continuar
                setOptions(<>
                    <div>
                        <Button type="text" disabled> 
                            <FileExcelOutlined />
                            Exportar a Excel
                        </Button>
                        {/* <Button type="text">
                            <FileExcelOutlined />
                            Exportar a Excel
                        </Button> */}
                    </div>
                    <Button type="text" disabled={continueDisabled} onClick={continueButton}>
                        <RightCircleOutlined />
                        Continuar
                    </Button>
                </>)
                break;
            // case 3:
            //     setOptions(<></>)
            //     break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step, continueDisabled])

    const continueButton = () => {
        if (step === 1) {
            const nextStep = [...codesPartial].length > 0 ? 2 : 3
            setStep(nextStep)
            if (nextStep === 2) {
                setContinueDisabled(true)
            }
        }


        console.log('Continue from step ', step)

        if (step === 2) {
            console.log('Resumen', {
                detailExcel,
                detailExcelDetail
            })
            setStep(3)
        }
    }

    const createTooltip = (listStocks: any[]) => {
        if (!listStocks || !listStocks.length) {
            return <><i>Sin stock disponible.</i></>
        }
        return <><strong>Stock: </strong>
            <ul>{listStocks.map(l => {
                return <li>{l}</li>
            })}</ul>
        </>
    }

    const [refStock, setRefStock] = useState<any[]>([])
    const rStk = useRef<any>()
    useEffect(() => {
        if (detailExcelDetail && detailExcelDetail.length > 0) {
            const _stocks = []
            for (const lineExcelDetail of detailExcelDetail) {
                const sku = lineExcelDetail[0]?.value
                const newValue = Number(lineExcelDetail[7]?.value)
                _stocks.push({sku, newValue})

                // const ndx = _stocks.findIndex(s => s.sku === sku)
                // if (ndx > -1) {
                //     _stocks[ndx].newValue = Number(_stocks[ndx].newValue) + Number(newValue)
                // } else {
                //     _stocks.push({ sku, newValue: isNaN(Number(newValue)) ? 0 : Number(newValue) })
                // }
            }

            setRefStock(_stocks)
            rStk.current = _stocks
        }
    }, [detailExcelDetail])

    // Chequear stocks
    useEffect(() => {
        if (step === 2 && detailExcelDetail && detailExcelDetail.length > 0) {
            const comparission = []
            for (const lineExcelDetail of detailExcelDetail) {
                const sku = lineExcelDetail[0]?.value
                const qty = Number(lineExcelDetail[7]?.value)
                comparission.push({ sku, qty })
            }

            const resume = comparission.reduce((acc: any[], item) => {
                const ndx = acc.findIndex((a: any) => a.sku === item.sku)
                if (ndx > -1) {
                    acc[ndx] = {
                        sku: item.sku,
                        qty: Number(item.qty) + Number(acc[ndx].qty)
                    }
                } else {
                    acc.push({ sku: item.sku, qty: item.qty })
                }
                return acc
            }, [])

            for (const lineResume of resume) {
                const gretaCode = preorder.homologated.find((h: any) => h.SKUCliente === lineResume.sku)?.CodComercial
                const lotesAlmacen = preorder.productoStock.filter((pS: any) => {
                    // pS.Cd_Alm === cell.Cod && 
                    return pS.Cd_Comercial === gretaCode
                }).reduce((acc: number, item: any) => {
                    return acc + item.SALDO
                }, 0)
                lineResume.max = lotesAlmacen
                // console.log(gretaCode, lotesAlmacen)
            }

            let disabledButton = false
            for (const lineResume of resume) {
                if (!disabledButton && lineResume.max < lineResume.qty) {
                    disabledButton = true
                }
            }

            setContinueDisabled(disabledButton)
            // console.log(resume, )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailExcelDetail])

    const StockColViewer = ({ cell, line, ...props }: any) => {
        // cell: value, Cod, CodCom
        const sku = line.DET_ART_CLT
        let value = cell.value
        const lotesAlmacen = preorder.productoStock.filter((pS: any) => {
            // pS.Cd_Alm === cell.Cod && 
            return pS.Cd_Comercial === cell.CodCom
        })

        const max = lotesAlmacen.reduce((acc: any, item: any) => {
            return acc + item.SALDO
        }, 0) // {`Stock: ${max}`}

        const totalAssigned = rStk.current.reduce((acc: number, item: any) => {
            if (item.sku === sku) {
                return acc + item.newValue
            }
            return acc
        }, 0)
        
        if (`${value}` === "0") {
            value = '-'
        }
        
        // const available = isNaN(Number(`${value}`)) ? 0 : Number(`${value}`)
        // const requested = Number(cell.requested)

        // const listStocks = lotesAlmacen.reduce((acc: any[], item: any) => {
        //     if (item.SALDO > 0) {
        //         acc.push(<><strong>{item.Cd_Alm}: </strong> {item.NroLote} ({item.SALDO})</>)
        //     } 
        //     return acc
        // }, [])  

        // console.log(cell.CodCom, lotesAlmacen, available, listStocks)

        let icon = <Tooltip placement="right" title={`Máximo a distribuir: ${max}`}>
            {totalAssigned <= max
                ? <CheckCircleTwoTone twoToneColor={"#52c41a"} />
                : <StopTwoTone twoToneColor={'#eb2f96'} />}
            {/* {(max < requested && max > 0) && <MinusSquareTwoTone />} */}
            {/* {max === 0 && } */}
            {/* <InfoCircleTwoTone /> */}
        </Tooltip>

        // if (requested > max) {
        //     icon = <Tooltip placement="right" title={`Stock: ${max}`}>
                
        //     </Tooltip>
        // }
        // if (requested === 0) {
        //     icon = 
        // }

        // const icon = <StopTwoTone />
        // const icon = <MinusSquareTwoTone />
        // const icon = <WarningTwoTone />

        return <span className="Spreadsheet__data-viewer">{icon}{value}</span>;
    }

    const StockViewer = ({ cell, ...props }: any) => {
        // cell: value, Cod, CodCom
        let value = cell.value
        const lotesAlmacen = preorder.productoStock.filter((pS: any) => {
            // pS.Cd_Alm === cell.Cod && 
            return pS.Cd_Comercial === cell.CodCom
        })

        const max = lotesAlmacen.reduce((acc: any, item: any) => {
            return acc + item.SALDO
        }, 0) // {`Stock: ${max}`}
        
        if (`${value}` === "0") {
            value = '-'
        }
        
        // const available = isNaN(Number(`${value}`)) ? 0 : Number(`${value}`)
        const requested = Number(cell.requested)

        const listStocks = lotesAlmacen.reduce((acc: any[], item: any) => {
            if (item.SALDO > 0) {
                acc.push(<><strong>{item.Cd_Alm}: </strong> {item.NroLote} ({item.SALDO})</>)
            } 
            return acc
        }, [])  

        // console.log(cell.CodCom, lotesAlmacen, available, listStocks)

        let icon = <Tooltip placement="right" title={createTooltip(listStocks)}>
            {max >= requested && max !== 0 && <CheckCircleTwoTone twoToneColor={"#52c41a"} />}
            {(max < requested && max > 0) && <MinusSquareTwoTone />}
            {max === 0 && <StopTwoTone twoToneColor={'#eb2f96'} />}
            {/* <InfoCircleTwoTone /> */}
        </Tooltip>

        // if (requested > max) {
        //     icon = <Tooltip placement="right" title={`Stock: ${max}`}>
                
        //     </Tooltip>
        // }
        // if (requested === 0) {
        //     icon = 
        // }

        // const icon = <StopTwoTone />
        // const icon = <MinusSquareTwoTone />
        // const icon = <WarningTwoTone />

        return <span className="Spreadsheet__data-viewer">{icon}{value}</span>;
    }

    useEffect(() => {
        console.log(codesBroken, codesPartial)
    }, [codesBroken, codesPartial])

    return <Row className="WarehouseInjector--Row">
        <DrawerResume data={data} />
        
        <Col span={24}>
            <Steps current={step} items={[
                { title: 'eOC', description: 'Archivo B2B' },
                { title: 'Stock', description: 'Cálculo actual' },
                { title: 'Distribución', description: 'Quiebres' },
                { title: 'Envío', description: 'Resumen' },
            ]} />

            {/* Carga de archivo */}
            {step === 0 && <div className="WarehouseInjector--Row--Step">
                <Row gutter={16}>
                    <Col xs={24} md={24}>
                        <Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <FileExcelFilled />
                            </p>
                            <p className="ant-upload-text">Selecciona archivos OC para cargar</p>
                            <p className="ant-upload-hint">
                                En este primer paso, debes cargar archivos exclusivamente de <strong>Órdenes de Compra OC</strong> desde el B2B de <strong>{rsocial}</strong>.
                            </p>
                        </Dragger>
                    {/* </Col>
                    <Col xs={24} md={12}> */}
                        <Form form={form} layout='horizontal' initialValues={{
                            validateStock: false,
                            isLimitedEdition: false,
                            validePrices: false,
                            otherWarehouse: false,
                            mdwFormatId: 1
                        }} onFinish={(values) => {
                            setData(values.orders)
                        }}>

                            <Form.List name="orders" rules={[
                                // { required: true, message: 'Necesitas cargar al menos un archivo eOC' }
                                {
                                    validator: async (_, orders) => {
                                        if (!orders || orders.length < 1) {
                                            message.error('Necesitas cargar al menos un archivo eOC')
                                            return Promise.reject(new Error('Necesitas cargar al menos un archivo eOC'))
                                        }
                                    }, message: 'Necesitas cargar al menos un archivo eOC'
                                }
                            ]}>
                                {(fields) => (
                                    <>
                                        {fields.map((field, i) => (
                                            <Space size={0} key={`${(form.getFieldValue('orders') ?? [])[field.key]?.path}`} style={{
                                                // display: 'flex',
                                                // marginBottom: 8,
                                                // justifyContent: 'space-between',
                                                // alignItems: 'flex-start',
                                                width: '100%',
                                                marginBottom: i === fields.length - 1 ? 48 : 0
                                            }}>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'path']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'filename']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    label="eOC Número"
                                                    name={[field.name, 'number']}
                                                    help={`${(form.getFieldValue('orders') ?? [])[field.key]?.filename}`}
                                                    tooltip='El número de la eOC debe ser el mismo que el número de la eOD'
                                                    rules={[
                                                        { required: true, message: 'Necesitas ingresar un número de eOC' },
                                                        { pattern: /^[0-9]+$/, message: 'Para el número de la eOC, solo se permiten números' },
                                                        {
                                                            validator: (_, value) => {
                                                                const _orders = form.getFieldValue('orders') ?? [];
                                                                const _order = _orders.filter((o: any) => o.number === value)

                                                                if (_order.length > 1) {
                                                                    message.error({
                                                                        content: 'Existen eOC con el mismo número, revísalas antes de continuar.',
                                                                        key: 'order-number-duplicated',
                                                                    })
                                                                    return Promise.reject('Existen eOC con el mismo número, revísalas antes de continuar.')
                                                                }
                                                                return Promise.resolve()
                                                            }, message: 'Existen eOC con el mismo número, revísalas antes de continuar.'
                                                        }
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Space>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                            
                        </Form>
                    </Col>
                </Row>
            </div>}

            {/* Visualización del archivo general */}
            {step === 1 && <div className="WarehouseInjector--Row--Step">
                <Row gutter={16}>
                    <Col md={24}>
                        {codesWithoutHomologation.length > 0 ? <Alert
                            message="Error: Faltan códigos de homologación"
                            description={<>
                            Para continuar, debes completar la siguiente información y volver a subir el archivo de orden de compra.
                                <ul>{codesWithoutHomologation.map(cW => <li>{cW}</li>)}</ul>
                            </>}
                            type="error"
                            showIcon
                            style={{
                                width: '100%'
                            }}
                        /> : <>
                            {[...codesBroken, ...codesPartial].length > 0 && <Alert
                                message={<>Esta órden cuenta con items {[(codesBroken.length > 0 ? "sin stock" : ""), (codesPartial.length > 0 ? "stock parcial" : "")].filter(a => a.trim().length > 0).join(" y ")}</>}
                                    description={<>Los items sin stock quedarán pendientes de procesar hasta que tengan stock y la orden siga vigente. {codesPartial.length > 0 && "Para enviar esta orden, en el siguiente paso deberás distribuir los items con stock parcial, según la distribución."}</>}
                                type="warning"
                                showIcon
                                style={{
                                    width: '100%'
                                }}
                            />}
                            {/* Broken: {JSON.stringify(codesBroken)}<br />
                            Partial: {JSON.stringify(codesPartial)} */}
                        </>}
                    </Col>
                    <Col md={24}>
                        <Spreadsheet
                            data={detailExcel}
                            onChange={setDetailExcel}
                            hideRowIndicators
                            // darkMode
                            columnLabels={columnLabels}
                        />
                    </Col>
                    {/*<Col md={6}>
                    <strong>Selección de Almacenes</strong>
                        <Select
                            mode="multiple"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Selecciona uno o más almacenes para incorporar al stock..."
                            // defaultValue={['a10', 'c12']}
                            onChange={(value, option) => {
                                console.log(value, option)
                                setSelectedAlmacenes(value as string[])
                            }}
                            options={almacenes.map(a => {
                                return {
                                    label: `${a.Codigo} - ${a.Nombre}`,
                                    value: a.Codigo
                                }
                            })}
                        />
                    </Col>*/}
                </Row>
            </div>}

            {/* Distribuición de quiebres */}
            {step === 2 && <div className="WarehouseInjector--Row--Step">
                <Row gutter={16}>
                    <Col md={24}>
                        <Spreadsheet
                            data={detailExcelDetail}
                            onChange={setDetailExcelDetail}
                            hideRowIndicators
                            // key={`${JSON.stringify(refStock)}`}
                            // darkMode
                            columnLabels={columnLabelsDetail}
                        />
                    </Col>
                </Row>
            </div>}

            {/* Selección de almacen y transferencia */}
            {step === 3 && <div className="WarehouseInjector--Row--Step">
                <Row gutter={16}>
                    <Col md={8}>
                    <strong>Selecciona almacen de destino</strong><br />
                    Selecciona un almacen para transferir la mercadería y comenzar su preparación.
                        <Select
                            // mode="multiple"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Selecciona un almacén..."
                            // defaultValue={['a10', 'c12']}
                            onChange={(value, option) => {
                                console.log(value, option)
                                setSelectedAlmacenes(value)
                            }}
                            disabled={loading_saveMdw}
                            options={almacenes.map(a => {
                                return {
                                    label: `${a.Codigo} - ${a.Nombre}`,
                                    value: a.Codigo
                                }
                            })}
                        />

                        <Button disabled={!selectedAlmacenes?.trim().length} onClick={async () => {
                            const formData = new FormData();
                            formData.append('payload', JSON.stringify({
                                general: detailExcel,
                                detail: detailExcelDetail,
                                preorder,
                                pickingAlm: selectedAlmacenes
                            }))

                            // console.log(formData)

                            // Aquí iría el fetch o axios
                            const answ = await saveMdw(formData)
                            console.log(answ)

                        }} loading={loading_saveMdw}>
                            Enviar
                        </Button>
                    </Col>


                    {facturable && <Col md={8}>
                        <strong>Generar OP</strong><br />
                        Una vez confirmado el picking, puedes generar las OP basados en el movimiento de inventario {data_saveMdw.contanet_trf[0]}.
                        <br />

                        <Button disabled={!facturable} onClick={async () => {
                            const formData = new FormData();
                            formData.append('payload', JSON.stringify({
                                orderId,
                                pickingAlm: selectedAlmacenes
                            }))

                            // console.log(formData)

                            // Aquí iría el fetch o axios
                            const answ = await createOP(formData)
                            console.log(answ)

                        }} loading={loading_createOP}>
                            Generar OP
                        </Button>
                    </Col>}
                </Row>
            </div>}
        </Col>
    </Row>
}
